import { render, staticRenderFns } from "./management-insight-card.vue?vue&type=template&id=2cf6d1e0&scoped=true&"
import script from "./management-insight-card.vue?vue&type=script&lang=js&"
export * from "./management-insight-card.vue?vue&type=script&lang=js&"
import style0 from "./management-insight-card.vue?vue&type=style&index=0&id=2cf6d1e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf6d1e0",
  null
  
)

component.options.__file = "management-insight-card.vue"
export default component.exports